import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../apiClient';
import { getQueryKeyBase, QUERY_KEYS } from '../queryClient';

// Config
import { crudConfig } from '../../../conf/predicatePartRels';

export const getQueryKey = getQueryKeyBase.bind(null, QUERY_KEYS.CRITERIA_PREDICATE_PART_RELS_METADATA);

export const useGetPredicatePartRelsMetadata = (sessionToken) => {
    const Client = apiClient(crudConfig.metadata);
    const query = useQuery({
        queryKey: getQueryKey(),
        queryFn: async () => {
            const config = await Client.fetch(sessionToken);

            if (!config) return {};
            return {
                constraintType: config?.fieldMap?.constraintType?.enum?.enumMap ?? {},
                resourceType: config?.fieldMap?.resourceType?.enum?.enumMap ?? {}
            };
        },
        onSuccess: (data) => {},
        onError: (data) => {
            console.log('Error', data);
        },
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });

    return {
        data: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        error: query.error,
        refetch: async () => {
            await query.refetch();
        }
    };
};
